module.exports = __webpack_public_path__ + "static/media/image-person.b607b314.png";